"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityQueryName = void 0;
var title_case_1 = require("./title-case");
var entityQueryName = function (entityTypeName) {
  var TYPE_NAME = (0, title_case_1.titleCase)(entityTypeName);
  return "".concat(TYPE_NAME, "Query");
};
exports.entityQueryName = entityQueryName;